// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"749":"css/app.7050","2495":"css/admin-app.7050"}[chunkId] + ".css";
};